define(['app'], function (app) {
  return app.Marionette.ItemView.extend({
    template: false,

    options: {
      container_id: '',
      nonce: ''
    },

    onRender: function () {
      var containerId = this.getOption('container_id')
      var nonce = this.getOption('nonce')

      if (containerId) {
        (function (w, d, s, l, i) {
          w[l] = w[l] || []
          w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
          })
          var f = d.getElementsByTagName(s)[0]
          var j = d.createElement(s)
          var dl = l !== 'dataLayer' ? '&l=' + l : ''
          j.async = true
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
          j.setAttribute('nonce', nonce)
          f.parentNode.insertBefore(j, f)
        })(window, document, 'script', 'dataLayer', containerId)
      }
    }
  })
})
